import { ProjectTodo } from './ducks';

// A single flattened outline row: the todo plus its visual position in the
// tree. `connectors[i]` is true when an ancestor at depth i has a following
// sibling (so a vertical guide line is drawn through that indent column).
export interface FlatRow {
  todo: ProjectTodo;
  depth: number;
  connectors: boolean[];
  hasChildren: boolean;
  collapsed: boolean;
}

// flattenProjectTree depth-first flattens a project's todo tree into a render
// list, skipping the subtrees of collapsed parents. Shared by the editable
// Outline and the read-only inbox InboxProjectsView so there is exactly one
// flatten implementation (connectors, depth, collapse semantics) in the app.
export function flattenProjectTree(
  roots: ProjectTodo[],
  childrenMap: Record<string, ProjectTodo[]>,
  collapsed: Set<string>,
): FlatRow[] {
  const out: FlatRow[] = [];
  const walk = (
    todo: ProjectTodo,
    depth: number,
    connectors: boolean[],
    isLastSibling: boolean,
  ) => {
    const kids = childrenMap[todo.id] ?? [];
    const isCollapsed = collapsed.has(todo.id);
    out.push({
      todo,
      depth,
      connectors,
      hasChildren: kids.length > 0,
      collapsed: isCollapsed,
    });
    if (isCollapsed) return;
    const kidConnectors = connectors.concat(!isLastSibling);
    for (let i = 0; i < kids.length; i++) {
      walk(kids[i], depth + 1, kidConnectors, i === kids.length - 1);
    }
  };
  for (let i = 0; i < roots.length; i++) {
    walk(roots[i], 0, [], i === roots.length - 1);
  }
  return out;
}
